import React, { useEffect, useId, useState } from 'react';
import Select from 'react-select';

type SelectInputProps = {
  isMandatory?: boolean;
  labelText?: string;
  name?: string;
  selectedOption: any;
  setSelectedOption(option: any): void;
  options: any[];
  isClearable?: boolean;
  isDisabled?: boolean;
  loadingMessageText: string;
  noOptionsMessageText: string;
};

const SelectInput = ({ loadingMessageText, noOptionsMessageText, labelText, name, selectedOption, setSelectedOption, options, isClearable, isDisabled, isMandatory }: SelectInputProps) => {

  const [isMounted, setIsMounted] = useState(false);

  // Check if the user is on a mobile device
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth <= 768);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => setIsMounted(true), []);
  const customClassNames = {
    control: () => 'text-blueH1 border rounded-l-cornerMob pl-3',
    // you can also customize other parts like:
    // menu: () => 'your-menu-class',
    // option: () => 'your-option-class',
  };

  const handleChange = (option: any) => {
    setSelectedOption(option);
  };

  if (!isMounted) {
    return null;
  }

  return (

    <div className="select-container">
      <Select
        name={name}
        className={`text-blueH1 w-full rounded-r-cornerMob text-xl h-full border-blueH1`}
        styles={{
          control: (base, state) => ({
            ...base,
            border: '10px',
            borderRadius: "1rem",
            fontSize: isMobile ? "1rem" : "1.25rem",
            width: "100%",
            minHeight: isMobile ? "54px" : "74px"
          }),
          placeholder: (base, state) => ({
            ...base,
            color: '#7a89b4',
          }),
          singleValue: (base, state) => ({
            ...base,
            color: '#041e68',
          }),
        }}
        classNamePrefix="select my-react-select"
        onChange={handleChange}
        value={selectedOption}
        options={options}
        placeholder={<div className={"dark:text-lightGreyH " + (selectedOption ? 'filled' : '')}>{labelText + (isMandatory ? '*' : '')}</div>}
        isClearable={isClearable}
        isDisabled={isDisabled}
        classNames={customClassNames}
        loadingMessage={() => <div className='text-blueH1 bg-smokeH text-base w-full'>{loadingMessageText}</div>}
        noOptionsMessage={() => <div className='text-blueH1 bg-smokeH text-base w-full'>{noOptionsMessageText}</div>}
      />
    </div>


  );
};

export default SelectInput;
